module.exports = __webpack_public_path__ + "static/img/todomath_main_feature_free_ja.32547e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/todomath_main_feature_free_ja.png
// module id = fPLB
// module chunks = 18